var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

require('./PasswordChange.less');

module.exports = Base.extend({

    el: '.PasswordChange',

    events: {
        'click .PasswordChange-buttons-button--cancel': 'cancelEdit',
        'click .PasswordChange-buttons-button--save': 'saveEdit',
        'click .PasswordChange-body-form-input-forgotPass': 'forgotPassword',
        'click .PasswordChange-confirmPopup-body-btn': 'hide',
        'input input': 'onInputChange'
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'getFormData');

        Base.prototype.initialize.call(this, options);
    },


    show: function () {
        this.$el.addClass('visible');
    },


    hide: function () {
        this.$el.removeClass('visible');
        this.$('.PasswordChange-confirmPopup').addClass('hidden');
        this.$('input').val('');
        this.$('.PasswordChange-buttons-button--save').removeClass('active');
    },


    saveEdit: function () {
        var form = this.getFormData();

        if (!form.valid) return;

        var $button = this.$('.PasswordChange-buttons-button--save');

        $button.addClass('Button--loading');

        this.saveXhr && this.saveXhr.abort();

        this.saveXhr = $.ajax(Urls['submissions:api:profile']('json'), {
            method: 'PUT',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                oldPassword: form.data.curPass,
                password: form.data.newPass
            }),
            success: function (responseData) {
                $button.removeClass('Button--loading');

                this.$('.PasswordChange-confirmPopup').removeClass('hidden');
            }.bind(this),
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    if (e.status == 400) { //bad request
                        $button.flashClass('Button--shake', 500);
                        this.$('input[name="curPass"]').addClass('error');
                    } else {
                        alert('Error ' + e.status + ': ' + e.statusText);
                    }
                }

                console.log('error', arguments);
            }.bind(this)
        });
    },


    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        this.hide();
    },


    forgotPassword: function () {
        window.location.href = Urls['submissions:forgot']();
    },


    onInputChange: function () {
        var data = this.getFormData();
        this.$('.PasswordChange-buttons-button--save').toggleClass('active', !!data.valid);
    },


    getFormData: function () {
        var curPass = this.$('input[name="curPass"]').val();
        var newPass = this.$('input[name="newPass"]').val();
        var confirmPass = this.$('input[name="confirmPass"]').val();

        var isConfirm = newPass == confirmPass;

        this.$('input[name="curPass"]').toggleClass('error', !curPass);
        this.$('input[name="confirmPass"]').toggleClass('error', !isConfirm);

        return {
            valid: curPass && newPass && isConfirm,
            data: {
                curPass: curPass,
                newPass: newPass
            }
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/PasswordChange/PasswordChange.js
// module id = 108
// module chunks = 0